module.exports = __webpack_public_path__ + "files/856cfffc39823b116dca73b92cb42c83.woff";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/lato-bolditalic-webfont.woff
// module id = 684
// module chunks = 60